import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.js";
import "@fontsource/montserrat";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Kolkata");

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
